module.exports = __webpack_public_path__ + "img/marker-oil-transport-grey.196ca35e.png";